import { MutationTree } from "vuex";
import { KbStateInterface } from "./state";

function arrayObjectIndexOf(myArray: any[], searchTerm: any, property: string) {
  for (let i = 0; i < myArray.length; i++) {
    if (myArray[i][property] === searchTerm) return i;
  }
  return -1;
}

const mutation: MutationTree<KbStateInterface> = {
  updateEntities(state: KbStateInterface, data) {
    state.entities[data.id] = data;
    // console.log(data);
  },

  updateSynonymsData(state: KbStateInterface, data) {
    state.synonyms.data = data;
    // console.log(data);
  },

  updateDescriptionsData(state: KbStateInterface, data) {
    state.descriptions.data = data;
  },

  updateEntitieName(state: KbStateInterface, ent) {
    state.entities[ent.id].name = ent.name;
  },

  saveSynonym(state: KbStateInterface, syn) {
    const idx = arrayObjectIndexOf(state.synonyms.data, syn.id, "id");
    state.synonyms.data[idx] = syn;
  },

  saveDescription(state: KbStateInterface, desc) {
    const idx = arrayObjectIndexOf(state.descriptions.data, desc.id, "id");
    state.descriptions.data[idx] = desc;
  },

  createEntity(state: KbStateInterface, { new_id, parent_id, name }) {
    // TODO: adding new entity to state
  },

  clearEntities(state: KbStateInterface) {
    state.entities = {};
  },

  createSynonym(state: KbStateInterface, { parent_id, syn_id, synonym }) {
    const new_syn = {
      ent_id: parent_id,
      id: syn_id,
      synonym: synonym,
    };
    state.synonyms.data.unshift(new_syn);
  },

  createDescription(
    state: KbStateInterface,
    { parent_id, desc_id, class_id, description }
  ) {
    const new_desc = {
      ent_id: parent_id,
      id: desc_id,
      class_id: class_id,
      description: description,
    };
    state.descriptions.data.unshift(new_desc);
  },

  deleteSynonym(state: KbStateInterface, id) {
    const idx = arrayObjectIndexOf(state.synonyms.data, id, "id");
    state.synonyms.data.splice(idx, 1);
  },

  deleteDescription(state: KbStateInterface, id) {
    const idx = arrayObjectIndexOf(state.descriptions.data, id, "id");
    state.descriptions.data.splice(idx, 1);
  },
};

export default mutation;
